import SurveyOfferCardWeb from "./SurveyOfferCardWeb";

export default SurveyOfferCardWeb;
